export default "__VITE_ASSET__Bz6b7PQo__"